export default "__VITE_ASSET__D90CMmOF__"